// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"b588c305","98":"0df541ee","344":"49d31bd9","429":"efcacd12","448":"d77ed7b5","483":"b56068c6","488":"cabf76df","608":"0678511b","652":"068ab069","722":"4754b030","916":"4325794c"}[chunkId] + ".chunk.js";
};